export default {
  medicLicense: "Datos profesionales",
  medicLicensePicture: "Foto de Registro MSP",
  medicLicensePictureDescription:
    "Envíanos una foto legible que acredite su registro médico. Nos ayuda a fortalecer tu seguridad y la de sus pacientes, y evita una posible suspensión de su cuenta.",
  stampPlaceholder: "Médico Cirujano \nRegistro MSP. 123456",
  customText: "Texto personalizado",
};
